import { ProductTagsLine } from 'Components/lines/product-tags-line/ProductTagsLine';
export default ProductTagsLine;
